"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.codenameHelper = exports.CodenameHelper = void 0;
class CodenameHelper {
    /**
     * This is used to prevent errors caused by reserved names in content item codename (e.g. 'constructor')
     */
    escapeCodenameInCodenameIndexer(codename) {
        return `_${codename}`;
    }
}
exports.CodenameHelper = CodenameHelper;
exports.codenameHelper = new CodenameHelper();
//# sourceMappingURL=codename.helper.js.map